import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Row, Col } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { useQuery, useMutation } from "graphql-hooks";

import ContentSection from '@components/common/ContentSection/ContentSection';
import ManageProducts from '@components/product/ManageProducts';
import Loader from '@components/common/Loader/Loader';
import Unavailable from '@components/common/Unavailable/Unavailable';

import { sendSuccessNotification, sendErrorNotification } from '@actions/notificationActions';

import { IProduct } from '@models/product';

const GET_PRODUCTS = `
  query GetProducts($id: ID!) {
    dropEvent(id: $id) {
      products {
        id
      }
      group {
        region
      }
    }
  }`;

const MODIFY_DROP_EVENT_PRODUCTS = `
  mutation modifyDropEventProducts(
    $dropEventId: ID!,
    $productIds: [ID]!
  ) {
    modifyDropEventProducts(
      dropEventId: $dropEventId,
      productIds: $productIds
    )
  }
`;

type ParamTypes = {
  dropEventId: string;
};

const ManageDropEventProducts: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const params = useParams<ParamTypes>();

  const { loading, error, data } = useQuery(GET_PRODUCTS, { variables: { id: params.dropEventId } })
  const [modifyDropEventProducts] = useMutation(MODIFY_DROP_EVENT_PRODUCTS)

  const handleSubmit = async (productIds: number[]) => {
    const { data, error } = await modifyDropEventProducts(
      {
        variables: {
          dropEventId: params.dropEventId,
          productIds: productIds,
        }
      }
    )

    if (error) dispatch(sendErrorNotification(error));
    else {
      dispatch(sendSuccessNotification(`Drop event products has been modified successfully`));
      history.push('/drop-events');
    }
  };

  if (loading) {
    return <Loader />;
  } else if (error) {
    dispatch(sendErrorNotification(error));
    return <Unavailable />;
  }

  return (
    <div>
      <div className="content">
        <Row>
          <Col xs={12} md={12}>
            <div className="page-title">
              <div className="float-left">
                <h1 className="title">Drop Event Products</h1>
              </div>
            </div>
            <div className="col-12">
              <ContentSection>
                <ContentSection.Header>Product Management</ContentSection.Header>
                <ContentSection.Body>
                  <div className="col-lg-12 dt-disp">
                    <ManageProducts
                      region={data.dropEvent.group.region}
                      productIds={data.dropEvent.products.map((product: IProduct) => product.id)}
                      onSubmit={handleSubmit} />
                  </div>
                </ContentSection.Body>
              </ContentSection>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ManageDropEventProducts;
